/* PRÉSET — quick-add, live cart count, drawer refresh.
   Mirrors the original behavior: variant dropdowns/pills retarget the add
   button; ADD TO CART works via the AJAX API; the drawer content and header
   count refresh without a reload. window.PresetCart exposes the drawer for
   the Kit-Builder's unlock-boundary auto-open. */
(function () {
  'use strict';

  function setCount(n) {
    document.querySelectorAll('#p-cart-count, [data-cart-count]').forEach(function (el) {
      el.textContent = n;
    });
  }

  async function getCart() {
    var r = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    return r.json();
  }

  async function refreshCount() {
    try { setCount((await getCart()).item_count); } catch (e) { /* non-fatal */ }
  }

  async function refreshDrawer() {
    try {
      // re-render the current page and swap in the fresh drawer — robust
      // regardless of which section renders it
      var r = await fetch(window.location.pathname, { headers: { Accept: 'text/html' } });
      var html = await r.text();
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('cart-drawer');
      var current = document.querySelector('cart-drawer');
      if (fresh && current) {
        var wasOpen = current.classList.contains('active') || current.hasAttribute('open');
        current.replaceWith(fresh);
        if (wasOpen) openDrawer();
      }
    } catch (e) { /* non-fatal */ }
  }

  function openDrawer() {
    var d = document.querySelector('cart-drawer');
    if (!d) return;
    if (typeof d.open === 'function') d.open();
    else d.classList.add('active', 'animate');
  }

  window.PresetCart = { getCart: getCart, refreshCount: refreshCount, refreshDrawer: refreshDrawer, openDrawer: openDrawer };

  // variant dropdown retargeting (cards + feature rows)
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-variant-select]');
    if (!sel) return;
    var card = sel.closest('[data-product-card]');
    if (!card) return;
    var opt = sel.selectedOptions[0];
    var add = card.querySelector('[data-add-to-cart]');
    if (add) add.dataset.variant = opt.value;
    var price = card.querySelector('[data-card-price]');
    if (price && opt.dataset.price) price.textContent = opt.dataset.price;
    var was = card.querySelector('[data-card-was]');
    if (was) {
      was.textContent = opt.dataset.was || '';
      was.style.display = opt.dataset.was ? '' : 'none';
    }
  });

  // add to cart
  document.addEventListener('click', async function (e) {
    var btn = e.target.closest('[data-add-to-cart]');
    if (!btn) return;
    e.preventDefault();
    var id = btn.dataset.variant;
    if (!id) return;
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    try {
      var r = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }),
      });
      if (!r.ok) throw new Error('add failed');
      await refreshCount();
      await refreshDrawer();
      btn.textContent = 'Added ✓';
      document.dispatchEvent(new CustomEvent('preset:cart:added'));
      setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 1400);
    } catch (err) {
      btn.textContent = 'Try again';
      setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 1400);
    }
  });

  // discount code field in the drawer — same behavior as the original:
  // registers the code for checkout, confirms inline
  document.addEventListener('click', async function (e) {
    var btn = e.target.closest('[data-drawer-coupon]');
    if (!btn) return;
    var box = btn.closest('.p-drawer-discount');
    var input = box.querySelector('[data-drawer-coupon-input]');
    var note = box.querySelector('[data-drawer-coupon-note]');
    var code = (input.value || '').trim();
    if (!code) return;
    try {
      await fetch('/discount/' + encodeURIComponent(code), { redirect: 'follow' });
      note.textContent = 'Code "' + code.toUpperCase() + '" will be applied at checkout.';
      note.hidden = false;
    } catch (err) {
      note.textContent = 'Could not apply the code. Try again.';
      note.hidden = false;
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.closest && e.target.closest('[data-drawer-coupon-input]')) {
      e.preventDefault();
      var b = e.target.closest('.p-drawer-discount').querySelector('[data-drawer-coupon]');
      if (b) b.click();
    }
  });

  // drawer quantity edits (Dawn posts cart changes itself) — watch and rebroadcast
  document.addEventListener('DOMContentLoaded', function () {
    refreshCount();
    var mo = new MutationObserver(function () {
      refreshCount();
      document.dispatchEvent(new CustomEvent('preset:cart:changed'));
    });
    var d = document.querySelector('cart-drawer');
    if (d) mo.observe(d, { childList: true, subtree: true });
  });
})();
